@use '../../../../styles/Colors.scss' as Colors;
@use '../../../../styles/Constants.scss' as Constants;

$var-bid-status-width: 100px;
$var-bid-status-filter-width: 150px;

.work-request-table {

	&__filters {
		display: flex;
		width: 100%;

		&__bid-status-container {
			display: flex;
			margin-left: Constants.$val-spacing-s;
		}

		&__bid-status {
			background-color: Colors.$col-white;
			border: 1px solid Colors.$col-greyConnection;
			// width: $var-bid-status-filter-width;
		}
	}


	&__double-cell {
		display: flex;
		flex-direction: column;
		justify-content: center;

		& > span {
			font-size: Constants.$val-fontSizeSmall;
			color: Colors.$col-greyMid;
		}
	}
	&__bid-status {
		color: Colors.$col-white;
		text-align: center;
		padding: 0 Constants.$val-spacing-m;
		border-radius: Constants.$val-borderRadius;
		font-weight: bold;
		font-size: Constants.$val-fontSizeSmall;
		min-width: $var-bid-status-width;
		text-overflow: hidden;

		&--in-progress {
			background-color: Colors.$col-yellow;
		}
		&--won {
			background-color: Colors.$col-green;
		}
		&--lost {
			background-color: Colors.$col-canceledRed;
		}
		&--locked-in {
			color: Colors.$col-blue;
			cursor: pointer;

			&:hover {
				color: Colors.$col-darkBlueBorder;
			}
		}
	}
}